module.exports = __webpack_public_path__ + "static/media/img.woman.pro.9ebbced4.png";